import React from 'react';
import { Paper, Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import BusinessIcon from '@mui/icons-material/Business';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BuildIcon from '@mui/icons-material/Build';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ApprovalIcon from '@mui/icons-material/Approval';
import DomainIcon from '@mui/icons-material/Domain';
import TitleBreadCrumbsContainer from '../../../containers/common/breadcurmbs/TitleBreadCrumbsContainer';
import ActionButtons from '../buttons/ActionButtons';
import MobileTitleBreadCrumbs from './MobileTitleBreadCrumbs';
import { useMobilePageHeader } from '../../../hooks/useMobilePageHeader';

const getTitleIcon = (icon) => {
  switch (icon) {
    case 'partner':
      return <BusinessIcon />;
    case 'product':
      return <InventoryIcon />;
    case 'user':
      return <AccountCircleIcon />;
    case 'taxbill':
      return <ReceiptIcon />;
    case 'pay':
      return <PriceCheckIcon />;
    case 'chance':
      return <AccountTreeIcon />;
    case 'tech':
      return <BuildIcon />;
    case 'dashboard':
      return <DashboardIcon />;
    case 'approval':
      return <ApprovalIcon />;
    case 'depart':
      return <DomainIcon />;

    default:
      return '';
  }
};

const TitleBox = ({
  edit,
  remove,
  isInitPwd,
  menuName,
  titleData,
  menuLink,
  handleEdit,
  handleRemove,
  handleInitPwd,
  handleGoBack,
  icon,
  editBtnText,
  editDelText,
}) => {
  const hasActions = Boolean(edit || remove || isInitPwd);

  // xs: 제목/뒤로가기/경로를 모바일 상단 앱바에 합쳐서 보여준다(이 Paper 자체는 xs에서 숨김).
  // 수정/삭제 등 액션이 있으면 앱바의 "⋯" 메뉴로 전달한다.
  useMobilePageHeader({
    title: titleData?.name,
    captionKey: menuName,
    onBack: handleGoBack,
    caption: <MobileTitleBreadCrumbs title={menuName} />,
    overflow: hasActions ? (
      <ActionButtons
        edit={edit}
        remove={remove}
        isInitPwd={isInitPwd}
        handleEdit={handleEdit}
        handleRemove={handleRemove}
        handleInitPwd={handleInitPwd}
        editBtnText={editBtnText}
        editDelText={editDelText}
      />
    ) : undefined,
  });

  return (
    <>
      <Paper
        sx={{
          display: { xs: 'none', sm: 'block' },
          backgroundColor: '#fafafa',
          position: { xs: 'sticky', sm: 'static' },
          top: 0,
          zIndex: { xs: 2, sm: 'auto' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: { xs: 0, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              minWidth: 0,
              flexGrow: 1,
            }}
          >
            <Box sx={{ pl: { xs: 0.5, sm: 1 }, pr: { xs: 0, sm: 1 } }}>
              <IconButton size="small" onClick={handleGoBack}>
                <ArrowBackIcon aria-label="goBack" fontSize="small" />
              </IconButton>
            </Box>

            <Box
              sx={{
                py: { xs: 0.5, sm: 1 },
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  display: { xs: 'none', sm: 'inline-flex' },
                  mx: 1,
                  color: '#fff',
                  bgcolor: 'info.main',
                  borderRadius: 1,
                  p: 0.3,
                }}
              >
                {getTitleIcon(icon)}
              </Box>

              <Box sx={{ ml: { xs: 1, md: 2 }, minWidth: 0, flexGrow: 1 }}>
                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                  <TitleBreadCrumbsContainer title={menuName} />
                </Box>
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                  <MobileTitleBreadCrumbs title={menuName} />
                </Box>
                <Typography
                  variant="subtitle1"
                  component="div"
                  color="primary.main"
                  sx={{
                    wordBreak: { xs: 'normal', sm: 'break-word' },
                    whiteSpace: { xs: 'nowrap', sm: 'normal' },
                    overflow: { xs: 'hidden', sm: 'visible' },
                    textOverflow: { xs: 'ellipsis', sm: 'clip' },
                    maxWidth: '100%',
                    fontSize: { xs: '1rem', sm: '1rem' },
                    fontWeight: { xs: 600, sm: 400 },
                  }}
                >
                  {titleData?.name}
                </Typography>
              </Box>
            </Box>
          </Box>
          <ActionButtons
            edit={edit}
            remove={remove}
            isInitPwd={isInitPwd}
            handleEdit={handleEdit}
            handleRemove={handleRemove}
            handleInitPwd={handleInitPwd}
            editBtnText={editBtnText}
            editDelText={editDelText}
          />
        </Box>
      </Paper>
    </>
  );
};

export default TitleBox;
